import { render, staticRenderFns } from "./FirmarFiniquito.vue?vue&type=template&id=56089d2d&"
import script from "./FirmarFiniquito.vue?vue&type=script&lang=js&"
export * from "./FirmarFiniquito.vue?vue&type=script&lang=js&"
import style0 from "./FirmarFiniquito.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports